import React, { useEffect, useState } from 'react';
import { Dropdown, FormHelperText } from '@hid-galaxy-ui/galaxy-react';
import { ISelectOptions } from '../../../utils/interfaces/ISelectOptions';
import  cx from 'classnames';
import './InputDropdown.scss';
import { getTranslation } from '../../../utils/functions';


interface IInputDropdownProps {
  field: any;
  form: any;
  required?: boolean;
  label?: string;
  hint?: string;
  options: ISelectOptions[];
  className?: string;
  isClearable?: boolean;
  onChange: (value: any) => void;
  value?: any;
  placeholder?: string;
}
const InputDropdown = (props:IInputDropdownProps) => {
  const { field, form, required=false, label, hint, className,onChange, options, isClearable=true, placeholder ='SELECT'} = props;
  const { name: fieldName, value: fieldValue } = field || {};
  const { errors, setFieldValue, setFieldTouched, touched } = form || {};


  const fieldError = fieldName && errors && errors[fieldName] ? errors[fieldName] : null;
  const hasError = Boolean(fieldError);
  const helperText = fieldError || hint;

  const shouldDisplayError = () => touched[fieldName] && !!errors[fieldName];


  const getSelectedValue = () => {
    if (fieldValue) {
      const obj = options.find((option) => option.value === fieldValue);
      return obj ? { label: obj.label, value: obj.value } : null;
    }
    return null;
  };

  const [selected, setSelected] = useState(fieldValue ? fieldValue : null);

 

  useEffect(() => {
    setSelected(getSelectedValue());
  }, [fieldValue, options]);


  const handleOnSelect = (selectedValueObj) => {
    if (fieldName && setFieldValue) {
      setFieldValue(fieldName, selectedValueObj?.value);
      // // Mark field as touched to trigger validation immediately
      // if (setFieldTouched) {
      //   setFieldTouched(fieldName, true);
      // }
    } 
    
    if (onChange) {
      onChange(selectedValueObj);
    }
    setSelected(selectedValueObj);
  };
  return (
    <div className={cx(className, 'dropdown-wrapper', {'dropdown-wrapper-error': helperText &&shouldDisplayError()})}>
      <Dropdown
        id={fieldName}
        selected={selected}
        label={label}
        options={options}
        isClearable={isClearable}
        isSearchable={true}
        onSelect={(value) => handleOnSelect(value)}
        placeholder={hint ? hint : getTranslation(placeholder)}
        isRequired={required}
        // helperText={shouldDisplayError() ? helperText : ''}

      />
           {helperText && <div className='hid-form-element--error'><FormHelperText>{shouldDisplayError() ? helperText : ''}</FormHelperText></div>}

    </div>
  );
};


export default InputDropdown;
